import { render, staticRenderFns } from "./label-detail-modal.vue?vue&type=template&id=657da623&scoped=true"
import script from "./label-detail-modal.vue?vue&type=script&lang=js"
export * from "./label-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657da623",
  null
  
)

export default component.exports